import { render, staticRenderFns } from "./personal-setting.vue?vue&type=template&id=e8145a76&scoped=true"
import script from "./personal-setting.vue?vue&type=script&lang=ts"
export * from "./personal-setting.vue?vue&type=script&lang=ts"
import style0 from "./personal-setting.vue?vue&type=style&index=0&id=e8145a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8145a76",
  null
  
)

export default component.exports